<template>
  <b-modal
    id="IndemnityPriceTemplateDeleteModal"
    v-model="isOpen"
    scrollable
    centered
    size="md"
    title="Удаление шаблона"
    @hidden="onClose"
    @ok="onClose"
  >
    <div>
      Вы уверены, что хотите удалить шаблон?
    </div>

    <template #modal-footer>
      <b-button
        variant="danger"
        class="float-right ml-2"
        :disabled="isLoading"
        size="sm"
        @click="onDelete"
      >
        Удалить
      </b-button>
      <b-button
        variant="outline-primary"
        class="float-right ml-2"
        :disabled="isLoading"
        size="sm"
        @click="onClose"
      >
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'IndemnityPriceTemplateDeleteModal',
  props: {
    modalName: {
      type: [String, Number],
      default: null,
    },
    template: {
      type: Object,
      default: null,
    },
    deleteTemplateCallback: {
      type: Function,
      default: () => {},
    },
  },

  data: () => ({
    isOpen: true,
    isLoading: false,
    data: {
      id: null,
      name: null,
      prices: [],
    },
    priceSearch: {
      name: '',
      isLoading: false,
      prices: [],
      fields: [
        {
          key: 'code',
          label: 'Код услуги',
        },
        {
          key: 'name',
          label: 'Название услуги',
        },
        {
          key: 'actions',
          label: '',
          tdClass: 'action-td',
          thClass: 'action-td',
        },
      ],
    },
  }),

  methods: {
    async onDelete() {
      this.isLoading = true;

      await this.$store.dispatch(this.$types.PRICE_TEMPLATE_DELETE, {
        templateId: this.template.id,
      });

      this.isLoading = false;

      this.deleteTemplateCallback();
      this.onClose();
    },
    onClose() {
      this.$store.commit(this.$types.CLOSE_MODAL, { modalName: this.modalName });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep#IndemnityPriceTemplateDeleteModal___BV_modal_outer_ {
  z-index: 1050!important;
}
</style>
